


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getuserlist,
  getPropertyDropdown,
  Propertydocuments,
  exportusers
} from "../../Api/AdminApiCall";

/* ===========================
   THUNKS
=========================== */

export const fetchgetuserApi = createAsyncThunk(
  "admin/fetchgetuserApi",
  async (
    { page = 1, search = "", status = "", fromDate = "", toDate = "" },
    { rejectWithValue }
  ) => {
    try {
      const res = await getuserlist(page, search, status, fromDate, toDate);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to load users"
      );
    }
  }
);

export const fetchExportusersApi = createAsyncThunk(
  "admin/fetchExportusersApi",
  async ({ search = '', status = '', affiliateType = '', fromDate = '', toDate = '' }, { rejectWithValue }) => {
    try {
      const res = await exportusers(search, status, affiliateType, fromDate, toDate);
      return res.data;
    }
    catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to export users"
      );
    }
  }
);
export const fetchPropertyDropdown = createAsyncThunk(
  "admin/fetchPropertyDropdown",
  async (accountId, { rejectWithValue }) => {
    try {
      const res = await getPropertyDropdown(accountId);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to load property dropdown"
      );
    }
  }
);

export const fetchPropertyDocument = createAsyncThunk(
  "admin/fetchPropertyDocument",
  async (propertyId, { rejectWithValue }) => {
    try {
      const res = await Propertydocuments(propertyId);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to load property documents"
      );
    }
  }
);

/* ===========================
   SLICE
=========================== */

const AdminuserSlice = createSlice({
  name: "Adminuserlist",
  initialState: {
    Userlist: [],
    propertydropdown: [],
    usersexport: [],

    // ✅ FIXED STRUCTURE
    Propertydocument: {
      data: null,
      loading: false,
      error: null,
    },

    loading: false,
    error: null,
  },

  /* ===========================
     REDUCERS
  =========================== */
  reducers: {
    // 🔥 IMPORTANT: clear old protest documents
    clearPropertyDocument: (state) => {
      state.Propertydocument.data = null;
      state.Propertydocument.loading = false;
      state.Propertydocument.error = null;
    },
  },

  /* ===========================
     EXTRA REDUCERS
  =========================== */
  extraReducers: (builder) => {
    builder
      /* -------- USERS -------- */
      .addCase(fetchgetuserApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchgetuserApi.fulfilled, (state, action) => {
        state.loading = false;
        state.Userlist = action.payload;
      })
      .addCase(fetchgetuserApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------- PROPERTY DROPDOWN -------- */
      .addCase(fetchPropertyDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPropertyDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.propertydropdown = action.payload;
      })
      .addCase(fetchPropertyDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchExportusersApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExportusersApi.fulfilled, (state, action) => {
        state.loading = false;
        state.usersexport = action.payload;
      })
      .addCase(fetchExportusersApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------- PROPERTY DOCUMENTS (FIXED) -------- */
      .addCase(fetchPropertyDocument.pending, (state) => {
        state.Propertydocument.loading = true;
        state.Propertydocument.error = null;
        state.Propertydocument.data = null; // 🔥 clear old data immediately
      })
      .addCase(fetchPropertyDocument.fulfilled, (state, action) => {
        state.Propertydocument.loading = false;
        state.Propertydocument.data = action.payload;
      })
      .addCase(fetchPropertyDocument.rejected, (state, action) => {
        state.Propertydocument.loading = false;
        state.Propertydocument.error = action.payload;
        state.Propertydocument.data = null;
      });
  },
});

/* ===========================
   EXPORTS
=========================== */

export const { clearPropertyDocument } = AdminuserSlice.actions;

export default AdminuserSlice.reducer;
